import { Component } from '@angular/core';

@Component({
  selector: 'app-irar-site-admin',
  template: `
  <p>Welcome to the BARC IR/AR Administrative Section. Within this area, you can control which
    administrative records are available to the general public.</p>

  <p>The Document Manager allows you to add and edit the documents viewable from this system.</p>
  `
})
export class AdminHomeComponent {}



// WEBPACK FOOTER //
// C:/Users/jstan/Projects/usda-document-client/src/app/modules/irar/components/admin.ts